import { isPlatformBrowser } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  PLATFORM_ID,
  ViewEncapsulation,
  inject,
  input,
  output,
  viewChild,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LandingDashboardCompareComponent } from "../../landing-dashboard-compare/landing-dashboard-compare.component";
import { LandingSectionRevealDirective } from "../../shared/landing-section-reveal.directive";
import { scrollToLandingSection } from "../../shared/landing-section-scroll.helper";

@Component({
  selector: "app-landing-1-hero",
  standalone: true,
  imports: [TranslateModule, LandingDashboardCompareComponent, LandingSectionRevealDirective],
  templateUrl: "./landing-1-hero.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1HeroComponent implements AfterViewInit, OnDestroy {
  readonly dashboardUrl = input.required<string>();

  readonly scrollTopVisibleChange = output<boolean>();

  private readonly heroTopSection = viewChild<ElementRef<HTMLElement>>("heroTopSection");
  private readonly platformId = inject(PLATFORM_ID);
  private observer?: IntersectionObserver;

  ngAfterViewInit(): void {
    // IntersectionObserver is a browser API; this hook also runs during
    // prerender, where it threw ReferenceError. The scroll-to-top toggle is
    // browser-only behaviour anyway.
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const section = this.heroTopSection()?.nativeElement;
    if (!section) {
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.scrollTopVisibleChange.emit(!entry?.isIntersecting);
      },
      { threshold: 0 },
    );

    this.observer.observe(section);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  scrollToSection(sectionId: string, event: Event): void {
    scrollToLandingSection(sectionId, event);
  }
}
